import { render, staticRenderFns } from "./resubmitAgentAbility.vue?vue&type=template&id=95ccf87c&scoped=true"
import script from "./resubmitAgentAbility.vue?vue&type=script&lang=js"
export * from "./resubmitAgentAbility.vue?vue&type=script&lang=js"
import style0 from "./resubmitAgentAbility.vue?vue&type=style&index=0&id=95ccf87c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ccf87c",
  null
  
)

export default component.exports